import { render, staticRenderFns } from "./orderAutomation.vue?vue&type=template&id=a2721524&scoped=true"
import script from "./orderAutomation.vue?vue&type=script&lang=js"
export * from "./orderAutomation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2721524",
  null
  
)

export default component.exports